import * as actionTypes from "./actionTypes";
import * as types from "./types";

const defaultState: types.NotificationState = {
    notifications: [],
};

const NotificationReducer = (state = defaultState, action: types.NotificationActions) => {
    switch (action.type) {
        case actionTypes.ENQUEUE_SNACKBAR:
            return {
                ...state,
                notifications: [
                    ...state.notifications,
                    {                                             
                        ...action.notification,                       
                    },
                ],
            };

        case actionTypes.CLOSE_SNACKBAR:
            return {
                ...state,
                notifications: state.notifications.map(notification => (
                    (action.dismissAll || notification.key === action.key)
                        ? { ...notification, dismissed: true }
                        : { ...notification }
                        )
                    ),
            };

        case actionTypes.REMOVE_SNACKBAR:
            return {
                ...state,
                notifications: state.notifications.filter(
                        notification => notification.key !== action.key,
                    ),
            };

            case actionTypes.CLOSE_ALL_SNACKBAR:
                return {
                    ...state,
                    notifications: 
                    state.notifications.map(notification => { return { ...notification, dismissed: true }}),
                };
    
            case actionTypes.REMOVE_ALL_SNACKBAR:
                return {
                    ...state,
                    notifications: [],
                };

        default:
            return state;
    }
};

export default NotificationReducer;